import { useMenu } from '../../hooks/useMenu'
import { MenuItem } from './MenuItem'

export const Menu = () => {
  const menu = useMenu()

  return menu?.length > 0 &&
    menu.map((menuItem, index) => {
      return (
        <MenuItem key={index} href={menuItem.path} disabled={menuItem.disabled}>
          {menuItem.name}
        </MenuItem>
      )
    })
}
